import { connect } from 'react-redux';
import NAV_DATA from '@zola-helpers/client/dist/es/constants/navConstants';

import requestPromoMessage from 'actions/PromoMessageActions';
import * as selectors from 'selectors/PromoMessageSelectors';
import { showModal } from 'actions/ModalActions';
import signupLinkCallback from 'components/common/auth/AuthModal/helpers/signupLinkCallback';

import PromotionalBar from './PromotionalBar';

const {
  EVENTS: { MODAL_TYPE_AUTH },
} = NAV_DATA;

const mapStateToProps = (state) => ({
  userContext: state.user.userContext,
  message: selectors.getPromoMessage(state),
  messageLoaded: selectors.getPromoMessageLoaded(state),
  link: selectors.getPromoMessageLink(state),
  busy: selectors.getPromoMessageBusy(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleRequestPromoMessage: () => dispatch(requestPromoMessage()),
  onShowLogin: () => {
    const path = window.location.pathname;
    const isInvitesDirectSignUpEnabled =
      path.indexOf('holiday-cards') !== -1 || path.indexOf('wedding-albums') !== -1;
    dispatch(
      showModal(
        MODAL_TYPE_AUTH,
        {
          authState: 'login',
          signupLinkCallback:
            isInvitesDirectSignUpEnabled &&
            window.zolaPaper &&
            window.zolaPaper.openSignUpModal instanceof Function
              ? () => window.zolaPaper.openSignUpModal()
              : () => signupLinkCallback(ownProps.activeLinkId),
        },
        { size: 'sm', ariaLabel: 'Log In' }
      )
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PromotionalBar);
